import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'

import Loader from '../Loader'
import Box from '../Box'
import { login } from '../../actions/auth-actions'
import { appName } from '../../constants/constants'
import WithErrorBoundaryWrapper from 'components/WithErrorBoundaryWrapper/WithErrorBoundaryWrapper'

/**
 * Lands here after the server exchanges the Ping SSO code and mints a normal
 * app JWT. The token travels in the URL fragment (never sent to a server /
 * access log). redirectUrl is restored from sessionStorage by the login saga.
 */
class SsoCallbackPage extends Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.hash.slice(1))
    const token = params.get('token')
    const email = params.get('email')
    const exp = params.get('exp')

    if (token && email && exp) {
      this.props.onLogin({ auth: { token, email, exp: Number(exp) } })
    } else {
      this.props.history.replace('/login?ssoError=1')
    }
  }

  render() {
    return (
      <DocumentTitle title={`${appName} | Signing in`}>
        <Box className="authView alignItemsCenter justifyContentCenter loginPage">
          <Loader height={45} />
        </Box>
      </DocumentTitle>
    )
  }
}

SsoCallbackPage.propTypes = {
  onLogin: PropTypes.func,
  history: PropTypes.object.isRequired
}

function mapDispatchToProps(dispatch) {
  return {
    onLogin: payload => dispatch(login(payload))
  }
}

export default WithErrorBoundaryWrapper(connect(null, mapDispatchToProps)(SsoCallbackPage), 'SSO callback page')
